import plugin from "tailwindcss/plugin.js"
const sizes = {
  "double-extra-small": "10px",
  "extra-small": "12px",
  small: "14px",
  medium: "16px",
  large: "18px",
  "extra-large": "20px",
  "double-extra-large": "24px",
  "triple-extra-large": "32px",
}
export default plugin(({ addUtilities }) => {
  addUtilities(
    Object.keys(sizes).reduce(
      (aggregate, key) => ({
        ...aggregate,
        [`.icon-${key}`]: {
          fontSize: sizes[key],
        },
      }),
      {}
    )
  )
})
